import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.admin;

export const isLoadingAdminSigninSelector = createSelector(
  getState,
  (state) => state.isLoadingAdminSignin,
);

export const brokerUsersSelector = createSelector(getState, (state) => state.brokerUsers);
export const brokerUsersMetaSelector = createSelector(getState, (state) => state.brokerUsersMeta);

export const isLoadingBrokerUsersSelector = createSelector(
  getState,
  (state) => state.isLoadingBrokerUsers,
);

export const repUsersSelector = createSelector(getState, (state) => state.repUsers);
export const repUsersMetaSelector = createSelector(getState, (state) => state.repUsersMeta);

export const isLoadingRepUsersSelector = createSelector(
  getState,
  (state) => state.isLoadingRepUsers,
);

export const adminContactsSelector = createSelector(getState, (state) => state.contacts);
export const adminContactsMetaSelector = createSelector(getState, (state) => state.contactsMeta);
export const isLoadingAdminContactsSelector = createSelector(
  getState,
  (state) => state.isLoadingContacts,
);

export const adminProposalsSelector = createSelector(getState, (state) => state.proposals);
export const adminProposalsMetaSelector = createSelector(getState, (state) => state.proposalsMeta);
export const isLoadingAdminProposalsSelector = createSelector(
  getState,
  (state) => state.isLoadingProposals,
);

export const brokerProposalsSelector = createSelector(getState, (state) => state.brokerProposals);
export const brokerbrokerProposalsMetaSelector = createSelector(
  getState,
  (state) => state.brokerProposalsMeta,
);
export const isLoadingBrokerProposalsSelector = createSelector(
  getState,
  (state) => state.isLoadingBrokerProposals,
);
